var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "dialog-fade" } },
    [
      _c("headerTitle", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        ref: "headerTitle",
        class: { "video-edit": _vm.isVideoEdit },
        attrs: { "z-index": _vm.zIndex },
        on: {
          onClickClear: _vm.onClickClear,
          change: _vm.tabChange,
          toggleMessageBox: _vm.toggleMessageBox,
        },
        nativeOn: {
          click: function ($event) {
            _vm.visible = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "tabOne",
            fn: function ({ row }) {
              return _c("fileTransfer", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: row === 1,
                    expression: "row === 1",
                  },
                ],
                ref: "fileTransfer",
                on: { numberChange: (res) => _vm.numberChange(1, res) },
              })
            },
          },
          {
            key: "tabTwo",
            fn: function ({ row }) {
              return _c("videoGeneration", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: row === 2,
                    expression: "row === 2",
                  },
                ],
                ref: "videoGeneration",
                on: { numberChange: (res) => _vm.numberChange(2, res) },
              })
            },
          },
          {
            key: "tabThree",
            fn: function ({ row }) {
              return _c("projectGeneration", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: row === 3,
                    expression: "row === 3",
                  },
                ],
                ref: "projectGeneration",
                on: { numberChange: (res) => _vm.numberChange(3, res) },
              })
            },
          },
          {
            key: "tabFour",
            fn: function ({ row }) {
              return _c("listDataExport", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: row === 4,
                    expression: "row === 4",
                  },
                ],
                ref: "listDataExport",
                on: { numberChange: (res) => _vm.numberChange(4, res) },
              })
            },
          },
          {
            key: "tabFive",
            fn: function ({ row }) {
              return _c("listOtherTask", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: row === 5,
                    expression: "row === 5",
                  },
                ],
                ref: "listOtherTask",
                on: { numberChange: (res) => _vm.numberChange(5, res) },
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }